var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-tags',{attrs:{"duplicate-tag-text":"Tag(s) duplicada(s)","invalid-tag-text":"Tag(s) inválida(s)","placeholder":"Adicione TAGs","remove-on-delete":"","name":"teste","required":_vm.required,"add-button-text":"Adicionar","value":_vm.value,"tag-validator":_vm.validator},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }